import { CheckCircle, XCircle, AlertCircle, Info } from "lucide-react";
import { ToastType } from "./types";

export const ToastIconFactory: Record<ToastType, () => JSX.Element> = {
  success: () => <CheckCircle className="w-5 h-5 text-green-500" />,
  error: () => <XCircle className="w-5 h-5 text-red-500" />,
  warning: () => <AlertCircle className="w-5 h-5 text-yellow-500" />,
  info: () => <Info className="w-5 h-5 text-blue-500" />,
};
